import React from 'react';
import { Switch } from 'antd';
import './Toggle.scss';

function Toggle({ datatestid, ariaLabel, tabIndex, ...props }) {
  return (
    <div
      data-testid={datatestid ? `${datatestid}-textBox` : null}
      className="toggle"
    >
      <Switch
        {...props}
        aria-label={ariaLabel}
        tabIndex={tabIndex}
        aria-hidden={'false'}
      />
    </div>
  );
}

export { Toggle };
